import React from "react";
import { useFormContext } from "react-hook-form";
import FormDatePicker from "../../../../../components/common/PL/DatePicker/FormDatePicker";
import FormSelect from "../../../../../components/common/PL/Select/FormSelect";
import { EntryRegistrationFormValues } from "../types";
import { isUnderAge, parseBirthDateValue } from "../../utils/visitorPersonalData";
import { genderOptions } from "../../utils/genderOptions";

type VisitorPersonalDataFieldsProps = {
  disabled?: boolean;
};

const VisitorPersonalDataFields = ({ disabled = false }: VisitorPersonalDataFieldsProps) => {
  const { watch } = useFormContext<EntryRegistrationFormValues>();
  const birthdateValue = watch("birthdate");
  const birthdate = React.useMemo(() => parseBirthDateValue(birthdateValue), [birthdateValue]);
  const showUnderAgeBadge = React.useMemo(() => isUnderAge(birthdate), [birthdate]);

  return (
    <>
      <FormDatePicker
        name="birthdate"
        label="Fecha de nacimiento"
        placeholder="-completar-"
        variant="pl"
        disabled={disabled}
      />

      <FormSelect
        name="sex"
        label="Género *"
        placeholder="-completar-"
        options={genderOptions}
        // En una salida los datos personales vienen bloqueados: si el usuario ya está adentro y
        // quedó sin género —los que no se pudo definir se dieron de alta como "n/a", que acá llega
        // vacío— no habría forma de completarlo y la salida no se podría registrar.
        rules={disabled ? undefined : { required: "El género es obligatorio" }}
        focusFirstOptionOnOpen
        disabled={disabled}
      />

      {showUnderAgeBadge && (
        <div className="visitorDataUnderAgeBadge">⚠️ MENOR DE EDAD - ACCESO CONDICIONADO</div>
      )}
    </>
  );
};

export default VisitorPersonalDataFields;
